import React, { FC } from 'react';

import { handleButtonSuffixUpload } from 'views/OfferDesign/OfferDesign.utils';

import UploadImage from 'components/UploadImage/UploadImage';

import { useFormFieldsContext } from '../../../context';
import { Spacing, SPACING_MAP, UploadFieldConfig } from '../FormFields.types';
import { getFormFieldValue } from '../FormFields.utils';

interface IFormFieldsUploadSectionProps {
  fields: UploadFieldConfig[];
  spacing?: Spacing;
}

const BUTTON_SUFFIX_FIELD = 'buttonSuffixBadge';

export const FormFieldsUploadSection: FC<IFormFieldsUploadSectionProps> = ({
  fields,
  spacing = 'md'
}): React.ReactElement => {
  const { values, setFieldValue, getFieldError, isFieldTouched } = useFormFieldsContext();

  return (
    <React.Fragment>
      {fields.map(({ title, fieldName, forceType, tooltip, isRequired, disabled }) => {
        const isButtonSuffix = fieldName === BUTTON_SUFFIX_FIELD;
        const isDisabled = disabled?.(values) ?? false;
        const error = isFieldTouched(fieldName) ? getFieldError(fieldName) : undefined;

        return (
          <div
            key={fieldName}
            className={`${SPACING_MAP[spacing]}${isDisabled ? ' opacity-50 pointer-events-none' : ''}`.trim()}
          >
            <UploadImage
              title={title}
              isRequired={isRequired}
              className="w-full !flex flex-row px-5"
              onUpload={
                isButtonSuffix
                  ? (url, name, mimeType) => handleButtonSuffixUpload(setFieldValue, url, name, mimeType)
                  : (url) => setFieldValue(fieldName, url)
              }
              selectedImageUrl={
                isButtonSuffix
                  ? values.buttonSuffixImage || values.buttonSuffixAnimation
                  : String(getFormFieldValue<string>(values, fieldName) ?? '')
              }
              forceType={forceType}
              TooltipContent={() => <span>{tooltip}</span>}
              hasError={!!error}
              errorMessage={error}
            />
          </div>
        );
      })}
    </React.Fragment>
  );
};
